import * as _ from "lodash";
import * as angular from "angular";
import { CampaignDataProvider } from "../../data-provider/campaign.dp";
import { FilterDataProvider } from "../../data-provider/filter.dp";
import { GroupDataProvider } from "../../data-provider/group.dp";
import { Filter } from "../../models/filter.model";
import { NavigationBarHelperService } from "../navigation/navigation-bar.helper";
import { PermissionCheck } from "../../shared/permission";
import { DialogUtils } from "../../helper/dialog.helper";
import { ToastUtils } from "../../helper/toast.helper";
import { HouseOccupantDataProvider } from "../../data-provider/house-occupant.dp";
import { CheckManager } from "../../shared/check-manager";
import { Group } from "../../models/group.model";
import { SearchUtils } from "../../helper/search.helper";

let HouseOccupantListComponent = {
    selector: "vcHouseOccupantList",
    templateUrl:
        "/angular/components/house-occupant/house-occupant-list.component.html",
    bindings: {
        group: "=?",
        hoid: "=",
    },
    controller: class HouseOccupantListController {
        // * bindings for typescript compiler *
        public group?: any;
        public hoid: any;
        // ************************************

        public filter: Filter;
        public isLeaderView: boolean;
        public upgrade: object | null = null;
        public search: string = "";
        public currency: string = "";
        public removeFromGroup: (ev: object) => void = undefined;
        public searchDelay: any;
        public checkManager: CheckManager;
        public warningBannerDismissed: boolean | undefined = undefined;
        public listBannerDismissed: boolean | undefined = undefined;

        private $scope: any;
        private $cookies: any;
        private $q: any;
        private $location: any;
        private $filter: any;
        private __env: any;
        private $interval: any;
        private dialog: DialogUtils;
        private toast: ToastUtils;
        private readonly $timeout: any;

        public houseOccupantDataProvider: HouseOccupantDataProvider;
        public searchUtils: SearchUtils;
        public permissionProvider: PermissionCheck;
        public navigationBarService: NavigationBarHelperService;
        public groupDataProvider: GroupDataProvider;
        public filterDataProvider: FilterDataProvider;
        public campaignDataProvider: CampaignDataProvider;

        constructor(
            $scope: any,
            $cookies: any,
            ToastUtils: ToastUtils,
            HouseOccupantDataProvider: HouseOccupantDataProvider,
            PermissionCheck: PermissionCheck,
            $q: any,
            SearchUtils: SearchUtils,
            NavigationBarHelperService: NavigationBarHelperService,
            GroupDataProvider: GroupDataProvider,
            FilterDataProvider: FilterDataProvider,
            $location: any,
            CampaignDataProvider: CampaignDataProvider,
            __app_type: string,
            $filter: any,
            __env: any,
            $interval: any,
            $timeout: any,
            DialogUtils: DialogUtils
        ) {
            this.$scope = $scope;
            this.$cookies = $cookies;
            this.$q = $q;
            this.$location = $location;
            this.$filter = $filter;
            this.$timeout = $timeout;
            this.__env = __env;
            this.$interval = $interval;
            this.dialog = DialogUtils;
            this.toast = ToastUtils;

            this.houseOccupantDataProvider = HouseOccupantDataProvider;
            this.searchUtils = SearchUtils;
            this.permissionProvider = PermissionCheck;
            this.navigationBarService = NavigationBarHelperService;
            this.groupDataProvider = GroupDataProvider;
            this.filterDataProvider = FilterDataProvider;
            this.campaignDataProvider = CampaignDataProvider;

            FilterDataProvider.setPage("database");
            this.filter = this.filterDataProvider.filter;
            this.isLeaderView = __app_type == "LEADER";
            this.warningBannerDismissed =
                this.$cookies.get("warningBannerDismissed") || false;

            if (this.filter.search && this.filter.search.values) {
                this.searchUtils.searchText = _.cloneDeep(
                    this.filter.search.values
                );
                this.search = this.searchUtils.searchText;
            }
            // check if upgrade is pending
            this.campaignDataProvider
                .checkCampaignUpgradePending()
                .then((upgrade: object) => {
                    this.upgrade = upgrade;
                });

            if (!this.isLeaderView) {
                this.searchUtils.setSearchBar(
                    "Search " +
                        this.$filter("capitalize")(this.__env.strings.voters),
                    (searchText: string): Promise<[]> => {
                        this.search = searchText;
                        return this.$q.resolve([]); //Not using the results for the search dropdown so return empty.
                    },
                    null,
                    true
                );
            }

            this.$scope.$watch(
                () => this.search,
                (newValue: string, oldValue: string) => {
                    if (oldValue != newValue) {
                        this.houseOccupantDataProvider.loading = true;
                        if (this.searchDelay) {
                            this.searchDelay = this.$interval.cancel(
                                this.searchDelay
                            );
                        }
                        this.searchDelay = this.$interval(() => {
                            this.$interval.cancel(this.searchDelay);
                            this.filterDataProvider.filter.search.values =
                                this.search;
                        }, 1000);
                    }
                },
                true
            );

            this.checkManager = this.houseOccupantDataProvider.checkManager;
            //Clear all checked when tab loads / Navigating back to.
            this.checkManager.checkAll(false);
        }

        $onInit() {
            if (this.group) {
                this.removeFromGroup = (ev: object) => {
                    this.dialog
                        .delete({
                            targetEvent: ev,
                            skipHide: true,
                            fullscreen: true,
                            locals: {
                                title: `Remove ${this.__env.strings.voters} from this list?`,
                                bodyText:
                                    "They will be permanently removed from this list. The contacts will still remain in your database.",
                            },
                        })
                        .then(() => {
                            this.checkManager.setLoading(true);
                            const filterCopy =
                                this.houseOccupantDataProvider.addGroupToFilter(
                                    this.filter,
                                    this.group
                                );
                            const bulkActionData =
                                this.checkManager.bulkActionData(
                                    new Filter(filterCopy)
                                );
                            bulkActionData["data_type"] = "people";

                            this.groupDataProvider
                                .bulkRemove(this.group.gid, bulkActionData)
                                .then(
                                    () => {
                                        this.houseOccupantDataProvider.resetItems();
                                        this.checkManager.setLoading(false);
                                        this.checkManager.checkAll(false);
                                        this.toast.success(
                                            "Contacts removed from list"
                                        );
                                    },
                                    () => this.toast.error()
                                );
                        });
                };
            }

            this.$timeout(() => {
                if (this.filterDataProvider.isSearchActive()) {
                    this.searchUtils.searchText = angular.copy(
                        this.filterDataProvider.non_empty_applied_fitlers.search
                    );
                    this.navigationBarService.setSearchMode(true);
                }
            }, 500);
        }

        anonymizeListModal(ev: object): void {
            this.showBulkDeleteDialog(true, ev);
        }

        deleteListModal(ev: object): void {
            this.showBulkDeleteDialog(false, ev);
        }

        bulkEditModal(ev: object): void {
            this.showBulkEditDialog(ev);
        }

        showBulkDeleteDialog(anonymize: boolean, ev: object): void {
            this.dialog
                .show({
                    component: "vc-bulk-delete",
                    targetEvent: ev,
                    scope: this.$scope,
                    locals: {
                        numItems:
                            this.houseOccupantDataProvider.checkManager
                                .checked_items_count,
                        itemType: "contact",
                        anonymize: anonymize,
                    },
                    ariaLabel: "Delete " + this.__env.strings.voter_file,
                })
                .then(() => {
                    this.houseOccupantDataProvider.bulkDelete(anonymize).then(
                        () => {
                            this.toast.success(
                                "Bulk delete contacts started, this may take a few minutes. You will be notified once it completes."
                            );
                        },
                        () => this.toast.error()
                    );
                });
        }

        openDuplicateDialog(duplicate: object, $event: object): void {
            this.dialog
                .show({
                    component: "vc-duplicate-dialog",
                    targetEvent: $event,
                    scope: this.$scope,
                    skipHide: true,
                    clickOutsideToClose: false,
                    locals: {
                        duplicate: duplicate,
                    },
                    ariaLabel: "Merge Contacts Dialog",
                    class: "duplicate-dialog",
                    size: "large",
                })
                .then((data: any) => {
                    this.toast.success(
                        this.$filter("capitalize")(this.__env.strings.voters) +
                            " merged"
                    );
                    this.houseOccupantDataProvider.removeFromFilteredHouseOccupants(
                        data.secondary
                    );
                    this.checkManager.checkAll(false);
                });
        }

        bulk_group(ev: object): void {
            this.dialog
                .show({
                    component: "vc-group-selection-dialog",
                    targetEvent: ev,
                    scope: this.$scope,
                    skipHide: true,
                    locals: {
                        provider: this.houseOccupantDataProvider,
                    },
                })
                .then((group: Group) => {
                    this.checkManager.setLoading(true);
                    let filterCopy =
                        this.houseOccupantDataProvider.addGroupToFilter(
                            this.filter,
                            this.group
                        );
                    let bulkActionData = this.checkManager.bulkActionData(
                        new Filter(filterCopy)
                    );
                    if (
                        (group.size ? parseInt(group.size) : 0) +
                            bulkActionData["checked_items_count"] >
                        20000
                    ) {
                        this.listTooBig();
                        return;
                    }
                    bulkActionData["constituent_filters_select_all"] = true;
                    bulkActionData["data_type"] = "people";

                    group
                        .addMembers({ members: [bulkActionData] }, this.dialog)
                        .then(
                            (group: Group) => {
                                this.checkManager.setLoading(false);
                                const message =
                                    this.$filter("capitalize")(
                                        this.__env.strings.voters
                                    ) +
                                    " added to " +
                                    group.gname;
                                this.toast.success(message);
                                this.checkManager.checkAll(false);
                            },
                            (data: any) => {
                                this.checkManager.setLoading(false);
                                if (data.tooBig) {
                                    this.listTooBig();
                                } else {
                                    this.toast.error();
                                }
                            }
                        );
                });
        }

        showBulkEditDialog(ev: object): void {
            this.dialog
                .show({
                    component: "vc-bulk-edit",
                    targetEvent: ev,
                    scope: this.$scope,
                    locals: {
                        numItems:
                            this.houseOccupantDataProvider.checkManager
                                .checked_items_count,
                    },
                    ariaLabel: "Bulk Edit Contacts",
                })
                .then((fieldEdit: any) => {
                    this.checkManager.setLoading(true);
                    this.houseOccupantDataProvider.bulkEdit(fieldEdit).then(
                        () => {
                            this.checkManager.setLoading(false);
                            this.toast.success(
                                "Bulk edit contacts started, this may take a few minutes. You will be notified once it completes."
                            );
                        },
                        () => {
                            this.checkManager.setLoading(false);
                            this.toast.error();
                        }
                    );
                });
        }

        listTooBig(): void {
            this.checkManager.setLoading(false);
            const listToBigAlert = this.dialog
                .alert()
                .title(`List Too Big`)
                .htmlContent(
                    `<p class="no-margin">We cannot complete this action as it will result in exceeding the list size maximum of 20,000 ${this.__env.strings.voters}.</p>
                        <p class="no-margin">List limits are in place to prevent excessive mobile data usage and provide an optimal experience using the mobile app.</p>`
                )
                .escapeToClose(false)
                .ok("Close");
            this.dialog.showPreConfiguredDialog(listToBigAlert);
        }

        showExport($event: object): void {
            if (this.permissionProvider.hasPermission("EXPORT")) {
                this.dialog
                    .show({
                        component: "vc-export-dialog",
                        scope: this.$scope,
                        size: "x-large",
                        targetEvent: $event,
                    })
                    .then((exportChoices: any) => {
                        this.houseOccupantDataProvider
                            .bulkExport(exportChoices)
                            .then(
                                () => {
                                    this.toast
                                        .action("Export Started", "Show")
                                        .then((value: string) => {
                                            if (value == "ok") {
                                                if (this.isLeaderView) {
                                                    this.$location.url(
                                                        "/leader_exports"
                                                    );
                                                } else {
                                                    this.$location.url(
                                                        "/exports"
                                                    );
                                                }
                                            }
                                        });
                                    this.checkManager.checkAll(false);
                                },
                                () => this.toast.error()
                            );
                    });
            } else {
                this.dialog.show({
                    component: "vc-export-disabled-dialog",
                    scope: this.$scope,
                    size: "large",
                    targetEvent: $event,
                });
            }
        }

        openUpgradePlanDialog(conversionType: string, ev: object): void {
            if (this.permissionProvider.hasBillingRight()) {
                this.dialog.show({
                    component: "vc-upgrade-plan-dialog",
                    targetEvent: ev,
                    scope: this.$scope,
                    locals: {
                        conversionType: conversionType,
                    },
                    fullscreen: true,
                    forceFullscreen: true,
                    size: "xx-large",
                    style: "background: #f6f6f6",
                });
            } else {
                this.dialog.show({
                    component: "vc-no-permission-upgrade",
                    targetEvent: ev,
                    scope: this.$scope,
                    locals: {},
                    size: "med",
                    style: "background: #f6f6f6",
                });
            }
        }

        isLargeList(): boolean {
            return (
                this.group &&
                !this.listBannerDismissed &&
                this.houseOccupantDataProvider.count > 20000
            );
        }

        isMaxLimitList(): boolean {
            return (
                this.group &&
                this.group.fid &&
                !this.listBannerDismissed &&
                this.houseOccupantDataProvider.count == 20000
            );
        }

        upgradePending(): boolean {
            return (
                !this.group &&
                !this.warningBannerDismissed &&
                this.upgrade != null
            );
        }

        dismissBanner(bannerDismiss: string): void {
            this[bannerDismiss] = true;
        }
    },
};

angular
    .module("houseoccupant")
    .component(HouseOccupantListComponent.selector, HouseOccupantListComponent);
